import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { ParagonThemeProvider } from '@paragon/themes';

import { store } from '../store';
import { chTheme, darkTheme, lightTheme } from '../themes';
import { RootComponent } from './RootComponent';
import { SyncClientManager } from './SyncClientManager';

interface Props {
  reduxStore: typeof store;
}

export default function ProductionClient(props: Props) {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Provider store={props.reduxStore}>
          <SyncClientManager />
          <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme} chTheme={chTheme}>
            <RootComponent />
          </ParagonThemeProvider>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  );
}
